<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">购物车添加</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="addOrderForm" :rules="rules" ref="addOrderForm">
                    <div>
                        <el-row>
                            <el-col :span="24" class="item">
                                <el-form-item label="选择商品数量" required prop="number">
                                    <el-input v-model.number="addOrderForm.number" placeholder="请输入商品数量"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" class="item" v-if="goodsType>1">
                                <el-form-item label="选择预约时间" required prop="planTime">
                                    <el-date-picker
                                        v-model="addOrderForm.planTime"
                                        type="datetime"
                                        placeholder="请选择预约时间"
                                        :default-value="new Date()"
                                        :picker-options="pickerOptions0"
                                        value-format="yyyy-MM-dd HH:mm:00"
                                        format="yyyy-MM-dd HH:mm:00"
                                        style="width:100%">
                                    </el-date-picker>
                                    </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addOrderForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        data() {
            return {
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },  
                loading: false,
                goodsType: '',
                addOrderForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    elderlyCode:'',
                    number:'',
                    planTime:'',
                    goodsCode:'',
                },
                rules:{
                    planTime:[
                        { required: true, message: '请选择预约时间', trigger: 'blur' },
                    ],
                    number:[
                        { required: true, message: '请输入商品数量', trigger: 'blur' },
                        { type: 'number', message: '商品数量为数字值'}
                    ],
                },
            }
        },

        methods: {
            init(row,elderlyCode){
                this.$refs.addOrderForm.resetFields();
                this.addOrderForm.elderlyCode=elderlyCode
                this.addOrderForm.goodsCode=row.goodsCode
                this.goodsType=row.goodsType
            },
            closeSelf() {
                this.$emit("closeAddOrder");
            },
            confirm(addOrderForm){
                this.$refs[addOrderForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        this.$message({type: 'info', message: '请完善信息'});
                        return false;
                    }
                })

            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.addOrderForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"AppCare/CartStaffAdd",
                    data: this.addOrderForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                             this.idCardImgFileList=[]
                            this.accountBookImgFileList=[]
                            this.$emit("closeAddOrder");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 500px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .upload-demo{
                margin-top: 40px;
            }
            .modal-body /deep/ .el-upload--picture {
                display: inline;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
